<div class="flex flex-row">
  <app-toolbar [items]="breadcrumbItems" class="w-100-percent"></app-toolbar>
</div>
<div class="flex flex-row justify-between items-center pl-24 pr-24 pb-8 pt-32">
  <div class="mat-headline-5 m-0">{{'LEFT_SIDE_NAV.COMPONENTS' | transloco }}</div>
  <div class="flex flex-row">
    <div class="flex flex-row justify-between items-center search-wrapper mr-16">
      <app-search-filter (keyup)="searchSolution($event)" [placeholder]="'COMPONENTS.SEARCH_COMPONENT'"></app-search-filter>
    </div>
    <div>
        <button *ngIf="permissionsMap[PermissionKeys.SOLUTION_CREATE]" type="button" class="flex justify-between items-center lob-gradient mat-subtitle-2 fw-700 m-0 pl-16 pr-16"
            mat-button (click)="addNewComponent()">
            <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
            {{'COMPONENTS.ADD_COMPONENTS' | transloco }}
        </button>
    </div>
  </div>
</div>
<div class="p-24">
  <div class="flex flex-col border-radius">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" class="mat-elevation">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'COMPONENTS.COMPONENT_NAME' | transloco | uppercase }}</th>
        <td mat-cell *matCellDef="let data" class="cursor-pointer">{{data.name}}</td>
      </ng-container>

      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'COMPONENTS.DISPLAY_NAME' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data"> {{data.displayName}} </td>
      </ng-container>

      <ng-container matColumnDef="version">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'INSTANCE_SUMMARY.VERSION' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data">{{data.version}}</td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'COMPONENTS.TYPE' | transloco | uppercase }} </th>
        <td mat-cell *matCellDef="let data">{{data.componentType}}</td>
      </ng-container>

      <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'COMPONENTS.CREATED_ON' | transloco | uppercase }} </th>
          <td mat-cell *matCellDef="let data">{{data.dateCreated}}</td>
        </ng-container>

    <ng-container matColumnDef="updatedOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"> {{'COMPONENTS.UPDATED_ON' | transloco | uppercase }} </th>
      <td mat-cell *matCellDef="let data"> {{data?.dateUpdated}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fs-14 fw-700"></th>
        <td mat-cell *matCellDef="let data" [matMenuTriggerFor]="instanceSubmenu"><mat-icon svgIcon="more_vert"></mat-icon>
          <mat-menu #instanceSubmenu [xPosition]="'before'" class="context-menu-dropdown">
            <div class="flex flex-col">
              <button class="menu-button" [ngClass]="{'disable' :!permissionsMap[PermissionKeys.SOLUTION_CREATE]}" (click)="editComponent(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="edit" class="icon-md"></mat-icon>
                  <div class="mat-body fw-400">{{'SOLUTIONS.EDIT' | transloco }}</div>
                </div>
              </button>
              <button class="menu-button" [ngClass]="{'disable' :!permissionsMap[PermissionKeys.SOLUTION_CREATE]}" (click)="deleteComponent(data)">
                <div class="flex flex-row justify-start items-center">
                  <mat-icon svgIcon="delete" class="icon-md"></mat-icon>
                  <div class="mat-body fw-400">{{'SOLUTIONS.DELETE' | transloco }}</div>
                </div>
              </button>
            </div>
          </mat-menu>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-card *ngIf="showSpinner" class="flex spinner-container spinner p-30">
      <mat-spinner diameter="24"
        color="primary"
        mode="indeterminate">
      </mat-spinner>
    </mat-card>
    <div *ngIf="componentsData?.length === 0 && !showSpinner && !isFailed" class="flex justify-center pt-48">
      {{'COMPONENTS.NO_COMPONENTS_AVALIABLE' | transloco }}
    </div>
    <div *ngIf="isFailed" class="flex items-center justify-center pt-48 pb-48">
      {{'INSTANCE_LIST.NO_DATA_FOUND' | transloco }}
    </div>
    <app-paginator *ngIf="showPagination && !showSpinner && !isFailed" class="p-24" [length]="componentsData?.length" [pageSizeOptions]="[10, 15, 20]"
      [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
  </div>
</div>
